import { DayPortion } from '../types/time-off-request';

/**
 * i18n key (within the `authenticated.timeOff` namespace) for the "duration"
 * value of a request day — i.e. how much of the day is taken off.
 */
export const DURATION_LABEL_KEY: Record<DayPortion, string> = {
  [DayPortion.Full]: 'details.duration.fullDay',
  [DayPortion.Half]: 'details.duration.halfDay',
  [DayPortion.Quarter]: 'details.duration.quarterDay',
  [DayPortion.Hourly]: 'details.duration.hourly',
};
